(function () {
    'use strict';

    angular
        .module('app.lostAndFound')
        .controller('LostAndFoundDetailsController', LostAndFoundDetailsController);

    LostAndFoundDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function LostAndFoundDetailsController($state, $stateParams, $window, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;

        vm.openDatePicker = openDatePicker;
        vm.dateFoundOpen = false;
            
        vm.datePickerOptions = {
            showWeeks: false,
            ngModelOptions: {
                allowInvalid: false
            }
        };

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem()];
           
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("lostandfound.list");
        }

        function openDatePicker($event) {
            vm.dateFoundOpen = true;
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.Id = '';
                var d = common.getMainState("mainDate");
                var now = moment().toDate();
                vm.item.DateFoundUtc = d;
                vm.item.TimeFoundDisplay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), now.getHours(), 0, 0, 0);
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/LostAndFound/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        common.setAuditInfo(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function save() {
            if (vm.item.Id == '') {
                vm.isSaving = true;
                var elmId = "photo";
                var imgInput = document.getElementById(elmId);
                var img = imgInput.files[0];

                if (!img) {
                    common.logger.error("Please choose a file to continue");
                    return;
                }

                var dto = {
                    "AltText": vm.item.AltText,
                    "Description": vm.item.Description,
                    "PlaceFound": vm.item.PlaceFound,
                    "DateFound": moment(common.buildDateTime(vm.item.DateFoundUtc, vm.item.TimeFoundDisplay)).format(),
                    "StorageLocation": vm.item.StorageLocation,
                }
                

               dataservice.postFile('api/LostAndFound/PostFile', img, dto).then(function (saveResult) {
                    vm.isSaving = false;
                    backToList();
               }).catch(function (error) {
                    vm.isSaving = false;
               });
            }
            else {
                
                var dto = {
                    "Id": vm.item.Id,
                    "AltText": vm.item.AltText,
                    "LongDescription": vm.item.LongDescription
                }

                dataservice.saveItem('api/PromotionalImages/Update', dto).then(function (saveResult) {
                    vm.isSaving = false;
                    backToList();
                }).catch(function (error) {
                    vm.isSaving = false;
                });
            }
            
        }

  
    }
})();
